import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEnUs from '@angular/common/locales/en';
import localeEnGb from '@angular/common/locales/en-GB';
import localeFr from '@angular/common/locales/fr';
import localeEsAr from '@angular/common/locales/es-AR';
import localeCa from '@angular/common/locales/ca';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {localeKeyLong} from '../constants/i18n.constants';
import * as moment from 'moment';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');

  // If the translations are in the server instead of in this project, we have to set here the endpoint that returns them.
  // return new TranslateHttpLoader(http, '/i18n?lang=', '');
}

export function initI18nConfig(langKeyLong: string): void {
  registerLocaleData(getAngularLocale(langKeyLong));
  moment.locale(langKeyLong);
}

function getAngularLocale(langKeyLong: string): void {
  let locale;
  switch (langKeyLong) {
    case localeKeyLong.ES:
      locale = localeEs;
      break;
    case localeKeyLong.AR:
      locale = localeEsAr;
      break;
    case localeKeyLong.FR:
      locale = localeFr;
      break;
    case localeKeyLong.CA:
      locale = localeCa;
      break;
    case localeKeyLong.ENUS:
      locale = localeEnUs;
      break;
    case localeKeyLong.ENGB:
    default:
      locale = localeEnGb;
  }

  return locale;
}
